"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataGrid = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var reactdatagrid_enterprise_1 = __importDefault(require("@inovua/reactdatagrid-enterprise"));
require("@inovua/reactdatagrid-enterprise/index.css");
var styles_1 = __importDefault(require("./styles"));
var defaultGridProps = {
    // disable reorder on default
    rowReorderColumn: false,
    // this can be set to a function and the row reorder column will be rendered
    onRowReorder: undefined,
    // sortable on static data is probably ok, but not on an infinite list
    sortable: false,
    // didn't want to enable this on default without talking with product first
    showColumnMenuTool: false,
    // need to default this to something generic that we will probably change later
    emptyText: 'No data to show',
    // don't show empty rows
    showEmptyRows: false,
    // no borders on data, will still have borders on header - should work well with zebra rows
    showCellBorders: false,
    // clicking a row should NOT cause it to be selected since we want to use checkboxes for that
    checkboxOnlyRowSelect: true,
};
/**
 * DataGrid wrapper for ReactDataGrid
 */
var DataGrid = function (props) {
    var classes = (0, styles_1.default)();
    return ((0, jsx_runtime_1.jsx)(reactdatagrid_enterprise_1.default, __assign({ className: classes.root, rowClassName: classes.row }, defaultGridProps, props)));
};
exports.DataGrid = DataGrid;
